export const OS_ZOOMSTACK_BASEMAP = 'OS Zoomstack' as const;
export const OS_MASTERMAP_GREY_SCALE_BASEMAP =
  'OS MasterMap Grey Scale' as const;

export const EMAPSITE_BASEMAPS = [
  OS_ZOOMSTACK_BASEMAP,
  OS_MASTERMAP_GREY_SCALE_BASEMAP,
] as const;

export type EmapsiteBasemap = (typeof EMAPSITE_BASEMAPS)[number];

export function isEmapsiteBasemap(title: string): title is EmapsiteBasemap {
  return (EMAPSITE_BASEMAPS as readonly string[]).includes(title);
}
